import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import { FaLandmark, FaRocket, FaSearch, FaUsers, FaMobileAlt, FaEuroSign, FaComments, FaCode, FaChartLine } from 'react-icons/fa';

const LandingPagesPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-empresas", text: "Página web barata para empresas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Convierte visitas en clientes reales",
      description: "Una landing page optimizada multiplica por 3-5 la tasa de conversión de una web normal. Cada 100 visitantes se convierten en 10-15 clientes potenciales reales."
    },
    {
      title: "Maximiza el retorno de inversión en publicidad",
      description: "Si inviertes en Google Ads o Facebook Ads, una landing específica reduce el coste por lead hasta en un 60%. Pagas lo mismo pero obtienes más clientes."
    },
    {
      title: "Resultados medibles desde el primer día",
      description: "Sabrás exactamente cuántos contactos genera cada campaña. Sin adivinar si funciona o no, con datos concretos que justifican la inversión."
    },
    {
      title: "Lanzamiento en tiempo récord",
      description: "En solo 3 días tendrás tu landing funcionando y captando clientes. Perfecto para promociones con fecha límite o servicios estacionales."
    },
    {
      title: "Diseño específico para tu objetivo",
      description: "A diferencia de una web genérica, cada elemento está diseñado para un único objetivo: conseguir que el visitante realice la acción que necesitas (llamar, comprar, reservar)."
    },
    {
      title: "Actualizable según resultados",
      description: "Podemos ajustar textos, imágenes o llamadas a la acción según el rendimiento. Una mejora continua que aumenta constantemente las conversiones y tus ingresos."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaLandmark />,
      title: "Diseño persuasivo que vende",
      description: "Estructura optimizada para guiar al visitante hasta el formulario o botón de contacto. Cada elemento está pensado para eliminar dudas y generar acción."
    },
    {
      icon: <FaSearch />,
      title: "Optimizada para palabras clave específicas",
      description: "Posicionamos tu landing para términos de búsqueda con alta intención de compra, atrayendo tráfico de calidad a bajo coste."
    },
    {
      icon: <FaUsers />,
      title: "Copys persuasivos centrados en beneficios",
      description: "Textos que hablan directamente a los problemas de tus clientes y presentan tu servicio como la solución ideal. Sin tecnicismos ni lenguaje confuso."
    },
    {
      icon: <FaMobileAlt />,
      title: "100% adaptada a móviles",
      description: "El 70% de visitas a landings vienen desde smartphones. Garantizamos experiencia perfecta en cualquier dispositivo para no perder ninguna conversión."
    },
    {
      icon: <FaEuroSign />,
      title: "Precio final sin sorpresas",
      description: "Desde 150€ (pago único) y solo 15€/mes de mantenimiento. Sin costes ocultos ni tarifas adicionales por cambios."
    },
    {
      icon: <FaChartLine />,
      title: "Análisis de rendimiento incluido",
      description: "Te proporcionamos informes mensuales de visitas y conversiones para que veas el retorno de tu inversión en números concretos."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Landing Page Básica',
      price: 150,
      period: 'pago único',
      description: 'Para promociones específicas o captar leads de una campaña concreta.',
      features: [
        { text: 'Una página optimizada para conversión', included: true },
        { text: 'Diseño responsive (móvil/tablet/PC)', included: true },
        { text: 'Formulario de contacto', included: true },
        { text: 'Textos persuasivos', included: true },
        { text: 'Integración con WhatsApp', included: true },
        { text: 'Optimización SEO básica', included: true },
        { text: 'Certificado SSL de seguridad', included: true },
        { text: 'Configuración de Analytics', included: true },
        { text: 'A/B Testing', included: false },
        { text: 'Integración con CRM', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=landing-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Landing Page Profesional',
      price: 250,
      period: 'pago único',
      description: 'La más elegida. Para campañas importantes con mayor presupuesto publicitario.',
      features: [
        { text: 'Una página optimizada para conversión', included: true },
        { text: 'Diseño responsive premium', included: true },
        { text: 'Formularios multietapa', included: true },
        { text: 'Copywriting avanzado', included: true },
        { text: 'Chat en vivo integrado', included: true },
        { text: 'Optimización SEO avanzada', included: true },
        { text: 'Certificado SSL de seguridad', included: true },
        { text: 'Configuración de Analytics + Pixel', included: true },
        { text: 'A/B Testing básico', included: true },
        { text: 'Integración con mail marketing', included: true },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=landing-pro',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Landing Page Avanzada',
      price: 350,
      period: 'pago único',
      description: 'Para campañas de alto valor con necesidades complejas y múltiples segmentos.',
      features: [
        { text: 'Multiple páginas de aterrizaje (2-3)', included: true },
        { text: 'Diseño premium personalizado', included: true },
        { text: 'Adaptación por segmentos de público', included: true },
        { text: 'Formularios inteligentes condicionales', included: true },
        { text: 'Pop-ups de conversión', included: true },
        { text: 'Sistema de seguimiento avanzado', included: true },
        { text: 'Configuración completa de eventos', included: true },
        { text: 'A/B Testing completo', included: true },
        { text: 'Integración con CRM/ERP', included: true },
        { text: 'Informes semanales de conversión', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=landing-avanzada',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis de tu objetivo y público",
      description: "Definimos qué acción quieres que hagan los visitantes (comprar, llamar, suscribirse) y estudiamos a tu cliente ideal para crear una landing que les hable directamente.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo en 3 días",
      description: "Creamos tu landing page con mensajes persuasivos, imágenes de calidad y elementos de conversión estratégicos, optimizada para generar la máxima cantidad de leads.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y optimización",
      description: "Activamos tu landing y medimos su rendimiento. Realizamos ajustes basados en datos reales para aumentar progresivamente la tasa de conversión y maximizar resultados.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para conversión",
      us: true,
      others: false
    },
    {
      label: "Textos persuasivos por copywriters",
      us: true,
      others: false
    },
    {
      label: "Entrega en 3 días laborables",
      us: true,
      others: false
    },
    {
      label: "Precio final sin costes ocultos",
      us: true,
      others: false
    },
    {
      label: "Análisis de resultados incluido",
      us: true,
      others: false
    },
    {
      label: "Modificaciones sin coste adicional",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Llevaba meses invirtiendo en Google Ads pero mi web no estaba convirtiendo visitantes en clientes. Probé con una landing page específica para mi servicio principal y la diferencia fue brutal. La tasa de conversión pasó del 1,8% al 8,5% en la primera semana, lo que representó 15 nuevos clientes que de otra manera habría perdido. La inversión se recuperó en menos de 7 días.",
    author: "Rafael Martínez",
    position: "Director",
    company: "Reformas Integrales Madrid",
    avatar: "/servicios/testimonios/reformas.webp"
  };
  
  // FAQs específicas para landing pages
  const faqs = [
    {
      question: "¿Por qué necesito una landing page si ya tengo una web?",
      answer: "Una web corporativa está diseñada para informar sobre tu empresa, mostrar todos tus servicios y establecer credibilidad, pero no está optimizada para convertir visitantes en clientes. Una landing page, en cambio, está diseñada con un único objetivo: conseguir que el visitante realice una acción específica (llamar, comprar, registrarse). Las estadísticas demuestran que las landing pages específicas convierten 3-5 veces mejor que una página genérica de una web. Los motivos son varios: eliminan distracciones (no hay menú de navegación), están totalmente enfocadas en un servicio específico, incluyen elementos psicológicos de persuasión (testimonios, garantías, urgencia), y tienen un mensaje perfectamente alineado con el anuncio que el usuario ha visto. Según nuestros datos, los clientes que dirigen su tráfico de pago (Google Ads, Facebook Ads) a landing pages específicas reducen su coste por lead en un 40-60% comparado con dirigirlo a su web general.",
      category: "Estrategia"
    },
    {
      question: "¿En cuánto tiempo estará lista mi landing page?",
      answer: "Una landing page básica o profesional puede estar lista en 3 días laborables desde la aprobación del briefing, lo que incluye: diseño personalizado según tu marca, redacción de textos persuasivos por copywriters especializados, configuración de formularios y elementos de conversión, implementación técnica y pruebas en todos los dispositivos. Para proyectos avanzados (con múltiples páginas o integraciones complejas), el plazo puede extenderse a 5-7 días. Ofrecemos también un servicio express con entrega en 24 horas para casos urgentes (+50€). El proceso está optimizado para entregar rápidamente sin comprometer la calidad ni la efectividad de la landing.",
      category: "Plazos"
    },
    {
      question: "¿Cómo medimos si la landing page está funcionando?",
      answer: "Implementamos un sistema completo de seguimiento en tu landing page que incluye: Google Analytics para monitorizar tráfico, comportamiento y eventos de conversión, seguimiento de llamadas telefónicas para saber qué llamadas provienen específicamente de la landing, píxeles de conversión para campañas de Facebook, Google Ads y otras plataformas publicitarias, y mapas de calor que muestran cómo interactúan los usuarios con la página. Con estos datos, generamos informes semanales o mensuales (según tus preferencias) que indican: número de visitas, tasa de conversión, coste por lead, tiempo de permanencia y otros KPIs relevantes. Estos informes incluyen recomendaciones concretas para mejorar el rendimiento. A diferencia de otras agencias que solo proporcionan datos brutos, nosotros te explicamos qué significan estos números y cómo impactan en tu negocio.",
      category: "Resultados"
    },
    {
      question: "¿Qué información necesito proporcionar para crear mi landing page?",
      answer: "Para crear una landing page efectiva necesitamos: información sobre tu servicio o producto (características, beneficios, precios), detalles sobre tu público objetivo (problemas que resuelves, objeciones comunes, motivaciones de compra), materiales gráficos como logo e imágenes (podemos ayudarte a conseguir buenas imágenes si no las tienes), ejemplos de landing pages que te gusten, objetivo principal de la landing (conseguir llamadas, formularios, ventas directas), y detalles de tu campaña publicitaria si ya está planificada. No te preocupes si no tienes toda esta información estructurada. Realizamos una entrevista inicial donde te guiamos con preguntas específicas para extraer lo necesario, y nuestros copywriters se encargan de transformar esta información en textos persuasivos que conectan con tus clientes potenciales.",
      category: "Proceso"
    },
    {
      question: "¿Puedo actualizar o modificar la landing page después de publicada?",
      answer: "Sí, todas nuestras landing pages incluyen modificaciones ilimitadas dentro del ámbito del proyecto. Esto significa que puedes solicitar cambios en textos, imágenes, colores, disposición de elementos o cualquier otro aspecto para mejorar el rendimiento o adaptarte a nuevas ofertas. Esto es especialmente valioso porque permite implementar mejoras basadas en datos reales de comportamiento de los usuarios. A diferencia de otros proveedores que cobran por cada pequeño cambio, nosotros incluimos las modificaciones en el precio de mantenimiento mensual de 15€. Para cambios mayores (como un rediseño completo o la implementación de nuevas funcionalidades no incluidas en el plan original) proporcionamos presupuestos transparentes. La mayoría de modificaciones se implementan en 24-48 horas.",
      category: "Mantenimiento"
    },
    {
      question: "¿Las landing pages incluyen SEO para posicionar en Google?",
      answer: "Sí, todas nuestras landing pages implementan optimización SEO básica, que incluye: meta-etiquetas optimizadas para las palabras clave objetivo, estructura adecuada de encabezados H1-H6, optimización de velocidad de carga (un factor clave de posicionamiento), texto con densidad óptima de palabras clave, imágenes con atributos alt relevantes, y estructura de URLs amigable. Sin embargo, es importante entender que las landing pages están principalmente diseñadas para tráfico de pago (Google Ads, Facebook, etc.) y no como páginas principales de posicionamiento orgánico. Para una estrategia SEO completa recomendamos nuestros servicios de posicionamiento web o la creación de páginas específicamente orientadas al SEO. En el caso de las landing pages, el SEO es un complemento que puede generar tráfico adicional, pero su principal fuente de visitas suele ser publicidad pagada donde el posicionamiento es inmediato.",
      category: "SEO"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para landing pages
      pageTitle="Landing Pages desde 150€ | Páginas de Aterrizaje que Convierten Visitas en Clientes"
      pageDescription="Diseñamos landing pages optimizadas para conversión. Ideales para captar leads, promocionar servicios específicos y maximizar el retorno de tus campañas publicitarias."
      pageKeywords="landing page barata, página de aterrizaje, diseño landing page, landing page optimizada conversión, landing page profesional"
      canonicalUrl="https://webabajocoste.es/servicios/landing-pages"
      
      // Hero adaptado al buyer persona
      heroTitle="Landing Pages desde 150€ (que convierten visitantes en clientes)"
      heroSubtitle="Páginas de aterrizaje optimizadas para conversión. Diseño profesional orientado a resultados que maximiza el retorno de tus campañas en Google y Facebook Ads."
      heroImage="/servicios/tipo-cliente/hero-landing.webp"
      badges={['Desde 150€ (pago único)', 'Entrega en 3 días', 'Optimizadas para conversión', 'Mantenimiento 15€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/contacto"
      
      // Secciones adaptadas
      pricingTitle="Landing Pages para diferentes objetivos"
      pricingSubtitle="Elige el plan que mejor se adapte a tus necesidades de conversión. Todos incluyen soporte técnico y mantenimiento por 15€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestras landing pages son ideales para tu negocio?"
      features={features}
      
      processTitle="Creamos tu landing page en 3 pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu landing page?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="¿Qué conseguirás con una landing page optimizada?"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre landing pages"
      faqCategories={["Estrategia", "Plazos", "Resultados", "Proceso", "Mantenimiento", "SEO"]}
      faqs={faqs}
      
      ctaTitle="Multiplica las conversiones de tus campañas publicitarias"
      ctaDescription="Convierte tu inversión en publicidad en clientes reales. Una landing page bien diseñada puede triplicar tus resultados."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/contacto"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default LandingPagesPage; 

